import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import styled, { css, StyleSheetManager } from "styled-components";
import { MIcon, Flex, Button, Text } from './Uikit';
import { MetaContext } from "../context";
import { getDataById } from "./Utilities";

export function Product(props) {
  const {
    handle = () => void(0),
    children,
    active,
    appearance = "catalog",
    data,
    sm,
    provided,
    innerRef,
    order,
  } = {
    ...props,
  };

  const [loaded, setLoaded] = useState();

  useEffect(() => {
    // setTimeout(() => {
    setLoaded(true);
    // }, 100);
  }, []);

  const context = useContext(MetaContext);

  return (
    <>
      {appearance === "catalog" && (
        <>
          <CSSproduct
            onClick={() => handle(data["id"])}
            active={active}
            col={data["color"]}
            sm={typeof sm !== "undefined" && true}
          >
            {/* {i}  */}
            {data["image"] && loaded && (
              <CSSimage
                col={data["color"]}
                sm={typeof sm !== "undefined" && true}
                active={active}
                style={{ backgroundImage: `url(${data.image[0].url})` }}
              />
            )}

            <CSSproductInner>
              <CSSproductAct active={active} />

              <b>{data["name"]}</b>
              {/* <br />
                    <br />
                    {data["dosage"]} */}

              {data["ppu"] && <CSSprice> €&thinsp;{data["ppu"]}</CSSprice>}

              {!sm && (
                <CSStag0>
                  {data["goal"].map((oneGoalId, i) => (
                    <CSStag key={`${oneGoalId}`}>
                      {getDataById(context, oneGoalId, "goal") &&
                        getDataById(context, oneGoalId, "goal")["title"]}
                    </CSStag>
                  ))}
                </CSStag0>
              )}
            </CSSproductInner>

            <CSSbg active={active} col={data["color"]} />
          </CSSproduct>
        </>
      )}

      {appearance === "quiz" && (
         <>
          <CSSproductQuiz active={active}
          onClick={() => handle(data["id"])}
          >
            <Flex left>

              <CSSproductActCheck
               active={active}
              >
              </CSSproductActCheck>


              <CSSstackImg0>
                {data["image"] && (
                  <CSSstackImage
                    col={data["color"]}
                    active={false}
                    style={{
                      marginBottom: 0,
                      backgroundImage: `url(${data.image[0].url})`,
                    }}
                  />
                )}
              </CSSstackImg0>
              &nbsp;&nbsp;

                <CSSstackName>{data["name"]}</CSSstackName>


            </Flex>


          </CSSproductQuiz>
       </>
      )}


      {appearance === "stack" && (
        <>
          <Flex>
            <Flex left>
              <CSSstackImg0>
                {data["image"] && (
                  <CSSstackImage
                    col={data["color"]}
                    active={false}
                    style={{
                      marginBottom: 0,
                      backgroundImage: `url(${data.image[0].url})`,
                    }}
                  />
                )}
              </CSSstackImg0>
              &nbsp;&nbsp;
              <CSSstackProductName>
                <CSSstackName>{data["name"]}</CSSstackName>
              </CSSstackProductName>

            </Flex>

            <CSSstackProductName>
              <Button sm flat onClick={() => handle(data["id"])}>
                ×
              </Button>
            </CSSstackProductName>
          </Flex>
        </>
      )}

      {appearance === "stackExpanded" && (
        <CSSstackProduct0>
          <Flex>
            <CSSproductLine >

            <CSSdragHandle className='handle'>
              <MIcon color={`--main-border-color`} size={14}>menu</MIcon>
            </CSSdragHandle>


            <CSSorder>
              {order}
            </CSSorder>

              <CSSstackImg0>
                {data["image"] && (
                  <CSSstackImage
                    col={data["color"]}
                    active={false}
                    style={{
                      marginBottom: 0,
                      backgroundImage: `url(${data.image[0].url})`,
                    }}
                  />
                )}
              </CSSstackImg0>

              <Text nopadding bold sm>{data["name"]}</Text>

              <Text nopadding sm>{data["usage"]}</Text>

            </CSSproductLine>

            <Button sm flat onClick={() => handle(data["id"])}>
                ×
              </Button>



          </Flex>
        </CSSstackProduct0>
      )}


    </>
  );
}

const CSSstackProductName = styled.div`
    @media (max-width: 991px) {
      display: none;
    }
`

const CSSproductLine = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1em 1.3em 2em 2fr 2fr 2fr;
  justify-items: start;
  align-items: center;
  grid-column-gap: 1em;
`

const CSSdragHandle = styled.div`
  /* width: 2em; */
  font-weight: 600;
  font-size: 0.9em;
  color: var(--main-text-lighter-color);
`

const CSSorder = styled.div`
  /* width: 2em; */
  font-weight: 600;
  font-size: 0.9em;
  color: var(--main-text-lighter-color);
`

const CSSstackProduct0 = styled.div`
  /* height: 3em; */
  padding: 1em;
  transition: background-color 150ms ease-in-out;
  border-radius: var(--main-border-radius-small);
  &:hover {
    /* background-color: var(--main-bg-lighter-color); */
  }
`;

const CSSstackName = styled.div`
  flex-grow: 1;
`;

const CSSstackImg0 = styled.div`
  background: var(--main-bg-lighter-color);
  position: relative;
  width: 2em;
  height: 2em;
  border-radius: var(--main-border-radius-small);
  /* overflow: hidden; */
`;

const CSSproductInner = styled.div`
  position: relative;
  z-index: 0;
`;

export const CSSproduct = styled.div`
  border-radius: 1em;
  overflow: hidden;

  cursor: pointer;

  height: 100%;
  height: ${({ sm }) => (sm ? "80px" : "120px")};
  padding: 0.8em 1.2em;
  /* border: 1px solid #e6e6e6; */
  /* margin-bottom: 1em; */
  /* background-color: var(--main-bg-lighter-color); */
  position: relative;

  color: ${({ active }) =>
    active ? "var(--main-text-lighter-color);" : "var(--main-text-color);"};

  transition: box-shadow 150ms ease-in-out;
  box-shadow: ${({ active, col }) =>
    active ? `0px 0px 1px 1px ${col}` : "0px 1px 2px -8px rgba(0, 0, 0, 0)"};
  &:hover {
    box-shadow: ${({ active }) =>
      active ? "none" : "0px 6px 16px -6px rgba(0, 0, 0, 0.3)"};
    z-index: 10;
  }
  & em {
    transition: opacity box-shadow 250ms ease-in-out;
    opacity: ${({ active }) => (active ? "1" : "0")};
    box-shadow: 0px 1px 2px -8px rgba(0, 0, 0, 0);
  }
  &:hover em {
    opacity: 1;
    box-shadow: 0px 3px 4px -3px rgba(0, 0, 0, 0.9);
  }
`;

export const CSSproductAct = styled.em`
  /* display: ${({ active }) => (active ? "flex" : "none")}; */
  position: absolute;
  font-style: normal;
  top: -0.2em;
  right: -0.2em;
  z-index: 0;
  background: white;
  /* padding: 0.2em 0.45em; */
  width: 1.6em;
  height: 1.6em;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10em;
  padding-right: 0.1em;
  ${({ active }) =>
    active
      ? css`
          &::after {
            font-family: 'Materialicons';
            font-size: 1em;
            content: "done";
          }
        `
      : css`
          &::after {
            font-family: 'Materialicons';
            font-size: 1em;
            content: "done";
          }
        `}
        /* background: ${({ active }) =>
    active ? "#fff" : "transparent"}; */
`;

const CSStag0 = styled.div`
  padding: 0.4em 0;
`;
const CSStag = styled.div`
  font-size: 0.8em;
  font-weight: 500;
  margin-top: 0.4em;
  /* color: var(--main-text-lighter-color); */
  opacity: 0.6;
`;

const CSSprice = styled.div`
  font-size: 0.8em;
  font-weight: 600;
`;

export const CSSimage = styled.div`
  position: absolute;

  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  /* width: 280px;
  height: 160px; */
  background-color: ${({ col }) => (col ? col : "#e9e9e9")};
  /* background-color: 200%; */
  /* background-position: ${({ sm }) => (sm ? "35% 10%" : "40% 30%")}; */
  background-position: 50% 100%;
  /* margin-bottom: ${({ sm }) => (sm ? "-60px" : "-100px")}; */
  background-repeat: no-repeat;
  opacity: ${({ active }) => (active ? "0.2" : "1")};
  @media (max-width: 991px) {
    /* background-position: ${({ sm }) => (sm ? "35% 20%" : "40% -30%")}; */
  }
  background-size: 100px 70px;
`;

export const CSSstackImage = styled.div`
  position: absolute;
  border-radius: 0.4em;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  background-color: ${({ col }) => (col ? col : "#e9e9e9")};
  background-position: 50% 50%;
  background-repeat: no-repeat;
  opacity: ${({ active }) => (active ? "0.2" : "1")};
  @media (max-width: 991px) {
  }
  background-size: contain;
`;

const CSSbg = styled.div`
  background: ${({ col }) => (col ? col : "var(--main-bg-lighter-color)")};
  opacity: ${({ active }) => (active ? "0.2" : "1")};
`;

export function ProductImage({ props }) {
  const { active, style } = { ...props };
  return <CSSimage {...props} />;
}


const CSSproductActCheck = styled.div`
  cursor: pointer;
  width: 44px;
  position: relative;
  margin-right: 1em;
  border: 1px solid transparent;
  opacity: 0.4;
  /* &:hover{
    opacity: 1;
    border: 1px solid var(--main-border-color);
  } */
  width: 2em;
  height: 2em;
  border-radius: var(--main-border-radius-small);
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ active }) =>
    active
      ? css`
          &::after {
            font-family: 'Materialicons';
            font-size: 1em;
            content: "done";
          }
        `
      : css`
          &::after {
            font-family: 'Materialicons';
            font-size: 1em;
            /* content: "close"; */
          }
        `}
`


const CSSproductQuiz = styled.div`
  cursor: pointer;
  ${({ active }) =>
    active
      ? css`

        `
      : css`
          opacity: 0.4;
          &:hover{
            opacity: 1;
          }
        `}
`